/* unplugin-vue-components disabled */import { render } from "./CallsAutoAssistForm.vue?vue&type=template&id=ab559d74&scoped=true"
import script from "./CallsAutoAssistForm.vue?vue&type=script&lang=js"
export * from "./CallsAutoAssistForm.vue?vue&type=script&lang=js"

import "./CallsAutoAssistForm.vue?vue&type=style&index=0&id=ab559d74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab559d74"]])

export default __exports__